import { cn, Modal, Text, PrimaryButton, Icon } from "@artprov/design-system";

export default function ModalBorradorExistente({
  openModal,
  titulo = "Titulo del modal",
  onAcceptModal,
  onCancelModal,
  onCloseModal,
}) {
  const IconBody = ({ variant = "success" }) => {
    const iconName = {
      success: "check_circle",
      error: "cancel",
      warning: "error",
    }[variant];

    const iconColor = {
      success: "text-success-10",
      error: "text-error-10",
      warning: "text-warning-10",
    }[variant];
    return (
      <Icon
        icon={iconName}
        className="py-1"
        classNameIcon={cn(iconColor)}
        size="extra-large"
      />
    );
  };

  return (
    <Modal.Container
      open={openModal}
      className={cn("overflow-hidden")}
      onClose={onCloseModal}
      closeOnClickOutside={false}
    >
      <Modal.Content width={549} height="auto" className="overflow-hidden">
        <Modal.Header className="px-6">
          <Modal.Title className="text-center w-full">
            <div className="flex justify-center mb-1">
              <IconBody variant="warning" />
            </div>
            {titulo}
          </Modal.Title>
          <Modal.Close onClose={() => onCloseModal()} />
        </Modal.Header>
        <Modal.Body className="px-4 py-0 [&_.relative]:!w-full [&_.relative]:!min-w-0 [&_.overflow-x-auto]:!overflow-hidden">
          <Text
            variant="body1"
            className="text-tertiary-20 text-center w-full break-words whitespace-normal"
          >
            Solo podés tener una nómina activa a la vez. Si cargás un nuevo
            archivo, se eliminará la nómina que está en borrador.
          </Text>
        </Modal.Body>
        <Modal.Footer className="flex justify-center gap-2 px-6">
          <Modal.CancelButton
            onClick={() => {
              if (typeof onCancelModal === "function") onCancelModal();
            }}
          >
            Editar Borrador
          </Modal.CancelButton>
          <PrimaryButton
            size="small"
            onClick={() => {
              if (typeof onAcceptModal === "function") onAcceptModal();
            }}
            classNameIcon="text-tertiary-100"
          >
            Continuar
          </PrimaryButton>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Container>
  );
}
